module.exports = __webpack_public_path__ + "img/customer-banner.96624510.jpg";